import {CsvConfigJsonResult} from '../synoptic-configuration-csv-types';

export function isLinkToSynopticArgs(obj: any): CsvConfigJsonResult {
  let valid = true;
  let errors = [];

  if (obj.synopticName === undefined) {
    valid = false;
    errors.push({code: 'notExist', key: 'synopticName'});
  }
  if (typeof obj.synopticName !== 'string') {
    valid = false;
    errors.push({code: 'notText', key: 'synopticName', value: obj.synopticName});
  }

  return {result: valid, errors: errors};
}
